<template lang="pug">
.match-overview
  h2.overview-title 開催概要
  h3.match-name {{ matchDetail.name }}
  p.match-period
    | 期間 : {{ matchDetail.startDateTime | formatDate }} 〜 {{ (matchDetail.endDateTime - 1) | formatDate }}
  img.match-image(
    v-if="overviewImageUrl"
    :src="overviewImageUrl"
    :alt="matchDetail.name"
  )
  SectionContents(:sections="matchDetail.sections")
</template>

<script>
import SectionContents from '@/components/SectionContents'

export default {
  name: 'MatchOverview',
  components: {
    SectionContents,
  },
  props: {
    matchDetail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    overviewImageUrl() {
      if (!this.matchDetail.images || !this.matchDetail.images[0]) {
        return ''
      }
      return this.matchDetail.images[0].url
    },
  },
}
</script>

<style scoped lang="scss">
.match-overview {
  border-top: 3px solid $base-brand-color;
  padding-top: 14px;
}

.overview-title {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: bold;
  color: $base-color;
}

.match-name {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: bold;
  color: $base-color;
  line-height: 1.4;
}

.match-period {
  margin: 0 0 20px;
  font-size: 12px;
  color: #666;
}

.match-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 20px;
}

@include sp-layout {
  .overview-title {
    font-size: 16px;
  }

  .match-name {
    font-size: 18px;
  }
}
</style>
